import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';
import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components';

import CitationCard from '../CitationCard';
import styles from './styles';
import source from 'services/sources';

/*

class Headword extends Component {
  state = {

  };

  handleChange = e => {
    this.setState({
      state: e.target.value
    });
  };

  render() {
    const { classes, className, headword, ...rest } = this.props;
    const { } = this.state;

    console.log("CALLING CITATION CARD: ");
    
    let citations = headword.relationships.citations.sort((a, b) =>  a.attributes.quotation.localeCompare(b.attributes.quotation)); 
    
    citations.map(async (c) => {
      if (c.attributes.sourceType === "books" && c.attributes.bookId != null) {
        let book = await source.getBook(c.attributes.bookId);
        c.attributes.quotation = "_DATE_" + book.attributes.yearPublished + "_DATE_" + c.attributes.quotation;
        console.log(c.attributes.quotation);
      }
    }); 

    console.log(citations);
    
    return (
      <div>
        {
          citations.map(citation => (
            <CitationCard key={citation.id} citation={citation} />
          ))
        }
      </div>
    );
  }
} 

*/


class Headword extends Component {
  state = {
    citations: [],
    loading: true,
  };

  _req = 0; // guards against race conditions if props change quickly

  componentDidMount() {
    this.prepareCitations(this.props.headword);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.headword !== this.props.headword) {
      this.prepareCitations(this.props.headword);
    }
  }

  // Build citations with date prefix (await all before rendering)
  prepareCitations = async (headword) => {
    const req = ++this._req;
    this.setState({ loading: true });

    const raw = (headword?.relationships?.citations ?? []);

    const withDates = await Promise.all(
      raw.map(async (c) => {
        // clone to avoid mutating props
        const out = {
          ...c,
          attributes: { ...c.attributes },
        };
        let pubDate = "0";
        if (out.attributes.publishedDate != null && out.attributes.publishedDate != "") {
          pubDate = out.attributes.publishedDate.trim();
        } else if (out.attributes?.recordingDate != null && out.attributes?.recordingDate != "") {
          pubDate = out.attributes.recordingDate.trim();
        } else if (out.attributes?.sourceType === "books" && out.attributes?.bookId != null) {
          try {
            const book = await source.getBook(out.attributes.bookId);
            pubDate = book.attributes.yearPublished.trim();
          } catch (e) {
            console.error("getBook failed", e);
          }
        }
        pubDate = pubDate.replace(/^(.+)\/(.+)\/(.+)$/ , '$3' );
        pubDate = pubDate.replace(/^(.+)\/(.+)$/ , '$2' );
        pubDate = pubDate.replace(/\s?00:00:00$/ , '');
        pubDate = pubDate.replace(/\s?00:00$/ , '');
        out.attributes.quotation =
        `_DATE_${pubDate}_DATE_` + out.attributes.quotation;
        return out;
      })
    );

    // reverse sort AFTER updates so the order reflects the modified quotation
    const sorted = withDates.sort((a, b) =>
      b.attributes.quotation.localeCompare(a.attributes.quotation)
    );

    // only apply latest run
    if (this._req === req) {
      this.setState({ citations: sorted, loading: false });
    }
  };

  render() {
    const { citations, loading } = this.state;

    return (
      <div>
        {loading
          ? <div>Loading…</div>
          : citations.map((citation) => (
              <CitationCard key={citation.id} citation={citation} />
            ))
        }
      </div>
    );
  }
}


Headword.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  headword: PropTypes.object.isRequired
};

export default withStyles(styles)(Headword);
